import React from "react";
import "./ProjectTeamTab.css";

const ProjectTeamTab = ({
  teamData,
  teamMemberDetails,
  loadingTeamMembers,
  getUserDisplayInfo,
}) => {
  return (
    <div className="pgt-project-team-container">
      <div className="pgt-team-main-card">
        {loadingTeamMembers && (
          <div className="pgt-loading-overlay">
            <div className="pgt-loading-spinner"></div>
            <span className="pgt-loading-text">Loading team members...</span>
          </div>
        )}

        {teamData ? (
          <div className="pgt-team-content">
            {/* Team Header Section */}
            <div className="pgt-team-header">
              <div className="pgt-team-header-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="pgt-team-header-info">
                <h3 className="pgt-team-name">{teamData.teamName}</h3>
                <div className="pgt-team-badge">
                  <span className="pgt-team-id-badge">
                    ID: {teamData.teamId}
                  </span>
                  <span className="pgt-member-count-badge">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 11 9.66 11 8C11 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.79 13 2 14.79 2 17V19H14V17C14 14.79 10.21 13 8 13ZM16 13C15.71 13 15.38 13.02 15 13.05C16.19 13.89 17 15.02 17 16.5V19H22V17C22 14.79 18.21 13 16 13Z"
                        fill="currentColor"
                      />
                    </svg>
                    {teamData.teamMembers?.length || 0} Members
                  </span>
                </div>
              </div>
            </div>

            {/* Team Stats Section */}
            <div className="pgt-team-stats">
              <div className="pgt-stat-card">
                <div className="pgt-stat-value">
                  {teamData.teamMembers?.length || 0}
                </div>
                <div className="pgt-stat-label">Total Members</div>
              </div>
              {/* <div className="pgt-stat-card">
                <div className="pgt-stat-value">
                  {teamData.teamMembers?.filter(
                    (m) => m?.role === "Lead" || m?.role === "Manager",
                  ).length || 0}
                </div>
                <div className="pgt-stat-label">Team Leads</div>
              </div> */}
              {/* <div className="pgt-stat-card">
                <div className="pgt-stat-value">
                  {teamData.createdDate
                    ? new Date(teamData.createdDate).toLocaleDateString()
                    : "N/A"}
                </div>
                <div className="pgt-stat-label">Established</div>
              </div> */}
            </div>

            {/* Team Members Section */}
            <div className="pgt-members-section">
              <div className="pgt-members-header">
                <h4 className="pgt-members-title">Team Members</h4>
                <div className="pgt-members-divider"></div>
              </div>

              <div className="pgt-members-grid">
                {teamData.teamMembers && teamData.teamMembers.length > 0 ? (
                  teamData.teamMembers.map((memberId, index) => {
                    const userInfo = getUserDisplayInfo(memberId);
                    return (
                      <div key={index} className="pgt-member-card">
                        <div className="pgt-member-avatar-wrapper">
                          <div className="pgt-member-avatar">
                            {userInfo.avatar ? (
                              <img src={userInfo.avatar} alt={userInfo.name} />
                            ) : (
                              <span className="pgt-member-initials">
                                {userInfo.name
                                  ? userInfo.name
                                      .split(" ")
                                      .map((n) => n[0])
                                      .join("")
                                      .toUpperCase()
                                      .slice(0, 2)
                                  : "U"}
                              </span>
                            )}
                          </div>
                          <div className="pgt-member-status-indicator"></div>
                        </div>
                        <div className="pgt-member-info">
                          <div className="pgt-member-name">
                            {userInfo.name || "Unknown User"}
                          </div>
                          <div className="pgt-member-email">
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                                fill="currentColor"
                              />
                            </svg>
                            {userInfo.email || "No email"}
                          </div>
                          <div className="pgt-member-id">
                            <svg
                              width="10"
                              height="10"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 18C9.67 18 7.53 17.14 6 15.7C6.01 13.52 10 12.3 12 12.3C14 12.3 17.99 13.52 18 15.7C16.47 17.14 14.33 18 12 18Z"
                                fill="currentColor"
                              />
                            </svg>
                            ID: {memberId}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="pgt-empty-members">
                    <svg
                      width="64"
                      height="64"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                        fill="currentColor"
                      />
                    </svg>
                    <p>No team members found</p>
                    <span>
                      This team doesn't have any members assigned yet.
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="pgt-no-team">
            <div className="pgt-no-team-icon">
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 18C9.67 18 7.53 17.14 6 15.7C6.01 13.52 10 12.3 12 12.3C14 12.3 17.99 13.52 18 15.7C16.47 17.14 14.33 18 12 18Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h4 className="pgt-no-team-title">No Team Assigned</h4>
            <p className="pgt-no-team-message">
              This project doesn't have a team assigned yet. Please assign a
              team to see member details.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectTeamTab;

// import React from "react";

// const ProjectTeamTab = ({
//   teamData,
//   teamMemberDetails,
//   loadingTeamMembers,
//   getUserDisplayInfo,
// }) => {
//   return (
//     <div className="project-view-fade-in">
//       <div className="project-overview-single-card">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           {loadingTeamMembers && (
//             <div className="text-muted">
//               <small>Loading team members...</small>
//             </div>
//           )}
//         </div>

//         {teamData ? (
//           <div className="project-view-team-details-container">
//             <div className="project-view-overview-grid">
//               <div className="project-view-overview-row">
//                 <span className="project-view-overview-label">Team Name:</span>
//                 <span className="project-view-overview-value">
//                   {teamData.teamName}
//                 </span>
//                 <span className="project-view-overview-label">Team ID:</span>
//                 <span className="project-view-overview-value">
//                   {teamData.teamId}
//                 </span>
//               </div>

//               {/* Team Members Section */}
//               <div
//                 className="project-view-overview-row"
//                 style={{ display: "block" }}
//               >
//                 <span className="project-view-overview-label">
//                   Team Members:
//                 </span>
//                 <div className="team-members-grid mt-3">
//                   {teamData.teamMembers && teamData.teamMembers.length > 0 ? (
//                     teamData.teamMembers.map((memberId, index) => {
//                       const userInfo = getUserDisplayInfo(memberId);
//                       return (
//                         <div key={index} className="team-member-card">
//                           <div className="project-view-team-member-avatar">
//                             <i className="fas fa-user"></i>
//                           </div>
//                           <div className="team-member-info">
//                             <div className="team-member-name">
//                               {userInfo.name}
//                             </div>
//                             <div className="team-member-email">
//                               {userInfo.email}
//                             </div>
//                             <div className="team-member-id">
//                               <small className="text-muted">
//                                 ID: {memberId}
//                               </small>
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="text-center py-4 text-muted">
//                       <i className="fas fa-users fa-2x mb-3"></i>
//                       <p>No team members found</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="text-center py-5">
//             <div className="no-team-placeholder">
//               <i className="fas fa-users fa-3x text-muted mb-3"></i>
//               <h5 className="text-muted">No Team Assigned</h5>
//               <p className="text-muted mb-3">
//                 This project doesn't have a team assigned yet.
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProjectTeamTab;
